"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var referenceFormatter = function referenceFormatter(reference) {
  if (typeof reference === 'undefined') {
    return '';
  }

  return reference.substring(0, 2) + '-' + reference.substring(2);
};

exports.default = referenceFormatter;